import { render, staticRenderFns } from "./memberType.vue?vue&type=template&id=67d07788&scoped=true&"
import script from "./memberType.vue?vue&type=script&lang=js&"
export * from "./memberType.vue?vue&type=script&lang=js&"
import style0 from "./memberType.vue?vue&type=style&index=0&id=67d07788&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d07788",
  null
  
)

export default component.exports